import { AUTH_USER,  UNAUTH_USER, AUTH_ERROR, UNAUTH_USER_ERROR } from '../actions/types';

export default function reducerAuth(state = {}, action) {

    switch(action.type) {
        case AUTH_USER:
            return { ...state, error: '', authenticated: true, token: action.payload };
        case UNAUTH_USER:
            return { ...state, error: '', authenticated: false };
        case AUTH_ERROR:
            return { ...state, error: action.payload};
        case UNAUTH_USER_ERROR: // fail on signout
            return { ...state, error: action.payload};
        default:
            return state;
    }
}
